import { defineMessage } from 'services/localization';

export const messages = {
    approvers: defineMessage('approvers'),
    reviewers: defineMessage('reviewers'),
    requesters: defineMessage('requesters'),
    ruleDescription: defineMessage('rule_description'),
    ruleAutoApprovalButtonTitle: defineMessage('add_autoapproval_rule'),
    editors: defineMessage('editors'),
};
